import React from "react";
import ModalCommon from "components/ModalCommon";
import { IoWarningOutline } from "react-icons/io5";
import MaterialUI from "../../../../../../material-UI";
import * as S from "./styles";

interface ModalConfirmacaoCaixaMaeProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const ModalConfirmacaoCaixaMae: React.FC<ModalConfirmacaoCaixaMaeProps> = ({
  open,
  setOpen,
  onConfirm,
  isLoading,
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ModalCommon open={open} onClose={handleClose} setOpenModal={setOpen}>
      <S.Content>
        <S.Header>
          <S.IconContainer>
            <IoWarningOutline size={30} color="#2d5bff" />
          </S.IconContainer>
          <S.TitleText>Confirmação de Caixa Mãe</S.TitleText>
        </S.Header>
        <S.Body>
          <S.Text>
            Você está prestes a iniciar a fila como <strong>Corretor</strong>.{" "}
            <br />
            Ao confirmar, você será designado como o <strong>
              Caixa Mãe
            </strong>{" "}
            desta roleta.
            <br />
            <br />
            Você está ciente e deseja continuar?
          </S.Text>
        </S.Body>

        <S.Footer>
          <S.SecondaryButton onClick={handleClose}>Cancelar</S.SecondaryButton>
          <S.PrimaryButton onClick={onConfirm} disabled={isLoading}>
            {isLoading ? (
              <MaterialUI.CircularProgress size={18} color="inherit" />
            ) : (
              "Confirmar"
            )}
          </S.PrimaryButton>
        </S.Footer>
      </S.Content>
    </ModalCommon>
  );
};

export default ModalConfirmacaoCaixaMae;
